import React from "react";
import iconPatternThree from '../../../images/perform-2023-pattern3.svg';
import iconPatternFour from '../../../images/perform-2023-pattern4.svg';
import iconPatternFive from '../../../images/perform-2023-pattern5.svg';
// import { Parallax } from "react-scroll-parallax";

const Perform2023GridSection = ({ data }) => {
    return (
        <div className="cp-perform2023Grid">
            <div className="l--absolute l-absoluteThree">
                <img src={iconPatternThree} alt="" />
            </div>
            <div className="l--absolute l-absoluteFour">
                <img src={iconPatternFour} alt="" />
            </div>
            <div className="l--absolute l-absoluteFive">
                <img src={iconPatternFive} alt="" />
            </div>
            {/* <Parallax y={[0, 0]} speed={20}> */}
                <div className="cp-perform2023Grid__inner" data-aos="fade-up">
                    {data.perform23GridSectionHeader &&
                        <h2>{data.perform23GridSectionHeader}</h2>
                    }
                    {data.perform23GridSectionRepeaterSections &&
                        <div className="cp-perform2023Grid__sections l--flex">
                            {data.perform23GridSectionRepeaterSections.map((gridSectionsPerform, index) => (
                                <div className="cp-perform2023Grid__sections-grid" key={index}>
                                    {gridSectionsPerform.header &&
                                        <h3>{gridSectionsPerform.header}</h3>
                                    }
                                    {gridSectionsPerform.teaser &&
                                        <p dangerouslySetInnerHTML={{ __html: gridSectionsPerform.teaser }} />
                                    }
                                </div>
                            ))}
                        </div>
                    }
                </div>
            {/* </Parallax> */}
        </div>
    )
}
export default Perform2023GridSection;

